import { getIconBaseProps } from '../utils';

export const synthetics = {
  ...getIconBaseProps('synthetics'),
  width: '28px',
  height: '28px',
  viewBox: '0 0 28 28',
  fill: 'currentColor',
  xmlns: 'http://www.w3.org/2000/svg',
  body: (
    <>
      <path
        d='M5.48885 22.8442C4 21.3553 4 18.959 4 14.1665C4 9.37397 4 6.9777 5.48885 5.48885C6.9777 4 9.37397 4 14.1665 4C18.959 4 21.3553 4 22.8442 5.48885C24.333 6.9777 24.333 9.37397 24.333 14.1665C24.333 18.959 24.333 21.3553 22.8442 22.8442C21.3553 24.333 18.959 24.333 14.1665 24.333C9.37397 24.333 6.9777 24.333 5.48885 22.8442Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M16.0726 17.3434C16.0726 16.6416 16.6416 16.0726 17.3434 16.0726H18.6143C19.3161 16.0726 19.8851 16.6416 19.8851 17.3434V18.6143C19.8851 19.3161 19.3161 19.8851 18.6143 19.8851H17.3434C16.6416 19.8851 16.0726 19.3161 16.0726 18.6143V17.3434Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.44775 9.71857C8.44775 9.01672 9.01672 8.44775 9.71857 8.44775H10.9894C11.6912 8.44775 12.2602 9.01672 12.2602 9.71857V10.9894C12.2602 11.6912 11.6912 12.2602 10.9894 12.2602H9.71857C9.01672 12.2602 8.44775 11.6912 8.44775 10.9894V9.71857Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </>
  ),
};
